import { PaginationResponse } from '@/app/models/pagination';
import { System } from '@/app/models/system';
import { useChangeSystemStatusMutation, useSystemSearchQuery } from '@/app/services/systemsApi';
import CancelOrConfirmDialog from '@/components/common/dialogs/CancelOrConfirmDialog';
import LateralDrawer from '@/components/common/LateralDrawer';
import PageTitle from '@/components/common/pageTitle';
import TextButton from '@/components/common/TextButton';
import NewEditSystemDrawer from '@/components/systems/newEditSystemDrawer';
import SystemsTable from '@/components/systems/systemsTable';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

function Systems() {
  const { t } = useTranslation('systems');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedSystem, setSelectedSystem] = useState<System | null>(null);
  const [activateDialog, setActivateDialog] = useState(false);
  const [deactivateDialog, setDeactivateDialog] = useState(false);

  const [changeStatus] = useChangeSystemStatusMutation();

  const handleChangeStatus = async (active: boolean) => {
    console.log('here');
    if (!selectedSystem?.id) {
      return;
    }
    await toast.promise(
      changeStatus({
        id: selectedSystem?.id,
        active,
      }).unwrap(),
      {
        pending: t('common:processing.wait.a.moment') as string,
        success: active
          ? (t('system.activated.sucessfully') as string)
          : (t('system.deactivated.sucessfully') as string),
        error: t('common:processing.failed') as string,
      },
      {
        position: toast.POSITION.TOP_RIGHT,
      },
    );
    setActivateDialog(false);
    setDeactivateDialog(false);
    setSelectedSystem(null);
  };

  const { data: systems } = useSystemSearchQuery({
    bringAll: true,
    page,
    size: rowsPerPage,
    sortKey: 'name',
    sortDirection: 'ASC',
  });
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '15px',
      }}
    >
      <PageTitle title={t('systems')} subtitle={t('systems.subtitle') || ''} titleLabel={`( ${t('products')})`} />
      <Box sx={{ width: '100%', display: 'flex' }}>
        <TextButton
          sx={{ ml: 'auto', mb: 2 }}
          text={t('new.system')}
          onClick={() => {
            setDrawerOpen(true);
            setSelectedSystem(null);
          }}
        />
      </Box>
      <SystemsTable
        setSelectedItem={setSelectedSystem}
        setDrawerOpen={setDrawerOpen}
        data={systems as PaginationResponse<System>}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        handleActivate={() => setActivateDialog(true)}
        handleDeactivate={() => setDeactivateDialog(true)}
      />
      <LateralDrawer open={drawerOpen} setOpen={setDrawerOpen} position="right" size="normal">
        <NewEditSystemDrawer selectItem={selectedSystem} setDrawerOpen={setDrawerOpen} />
      </LateralDrawer>
      <CancelOrConfirmDialog
        open={activateDialog}
        title={t('activate')}
        contentText={t('activate.system.confirmation') || ''}
        onClose={() => {
          setActivateDialog(false);
          setSelectedSystem(null);
        }}
        onConfirm={() => handleChangeStatus(true)}
      />
      <CancelOrConfirmDialog
        open={deactivateDialog}
        title={t('deactivate')}
        contentText={t('deactivate.system.confirmation') || ''}
        onClose={() => {
          setDeactivateDialog(false);
          setSelectedSystem(null);
        }}
        onConfirm={() => handleChangeStatus(false)}
      />
    </div>
  );
}

export default Systems;
